module.exports = __webpack_public_path__ + "img/page.af251d17.png";